import React, {Component} from 'react';
import {Item, Segment, Button} from 'semantic-ui-react'
import axios from "axios";
import house from "./house";

class HouseCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            house: props.house,
        };
        this.onClickHandler = this.onClickHandler.bind(this);
    }

    onClickHandler(){
        const url = `http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/houses/${this.state.house._id}`;
        console.log(url);
        axios.delete(url).then((res)=>{
            console.log(res);
            let user = localStorage.getItem('user');
            let profile = JSON.parse(user);
            console.log(profile);
            profile.myHouse = profile.myHouse.filter(e => e !== this.state.house._id);
            console.log(profile);
            user = JSON.stringify(profile);
            localStorage.setItem('user', user);
            window.location = `${process.env.PUBLIC_URL}/users/profile`;
        }).catch((error) => {
            console.log(error);
        });
    }

    render() {
        const house = this.state.house;
        return (
            <Segment className="house_card">
                <Item.Group>
                    <Item className="item">
                        <Item.Image className="card_image" src={house.photo[0]} />
                        <Item.Content className="card_container">
                            <Item.Meta content={house.city + "·" + house.state} />
                            <Item.Header>{house.address}</Item.Header>
                            <Item.Description className="card_des">{"\"" + house.description + "\""}</Item.Description>
                            <Item.Extra>
                                <Button primary floated='left' onClick={this.onClickHandler} className = "delete_button">
                                    Delete post
                                </Button>
                            </Item.Extra>
                        </Item.Content>
                        <Item.Content className="cost-holder">
                            <Item.Header className="cost">{"$" + house.cost}</Item.Header>
                            <Item.Description className="cost-unit">{"/mon"}</Item.Description>
                        </Item.Content>
                    </Item>
                </Item.Group>
            </Segment>);
    }
}

export default HouseCard;